import { render, staticRenderFns } from "./SearchTeacher.vue?vue&type=template&id=f69aab30&scoped=true&lang=pug"
import script from "./SearchTeacher.vue?vue&type=script&lang=ts"
export * from "./SearchTeacher.vue?vue&type=script&lang=ts"
import style0 from "./SearchTeacher.vue?vue&type=style&index=0&id=f69aab30&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f69aab30",
  null
  
)

export default component.exports